import React, { Component } from 'react';
import {
  Typography,
  createStyles,
  WithStyles,
  withStyles,
  Grid,
  CardContent,
  Card,
  Theme,
  Avatar
} from '@material-ui/core';
import _ from 'lodash';
import dateService from '../../common/services/dateService';

const styles = (theme: Theme) => createStyles({
  mt1x: {
    marginTop: theme.spacing.unit * 2,
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  ml1x: {
    marginLeft: theme.spacing.unit * 2,
  },
  ml2x: {
    marginLeft: theme.spacing.unit * 4,
  },

  pl1x: {
    paddingLeft: theme.spacing.unit,
  },
  bold: {
    fontWeight: "bold",
  },
  inline: {
    display: "inline",
  },
  avatar: {
    margin: 10,
    display: 'inline',
    width: 25,
    height: 25,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  arrow: {
    display: "inline",
    float: "right",
    marginRight: "17px"
  },
  cardMain: {
    height: 543,
    overflowY: "auto",
    overflowX: "hidden",
    position: 'relative',
  },
  fixedHeight:{
    padding: '10px',
    height: '471px',
    overflowY: "auto",
    overflowX: "hidden",
  },
  cardContentRoot: {
    ...theme.mixins.gutters(),
    padding: '16px 5px !important',
    '& ul': {
      listStyle: 'none',
      display: 'flex',
      padding: 0,
      margin: 0,
    }
  },
  lineClamp: {
    fontWeight: 400,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  },
  commentCard: {
    padding: "5px !important",
    fontSize: '13px',
    minHeight: '90px'
  },
  noContent: {
    margin: 0,
    position: "absolute",
    top: "50%",
    marginRight: "-50%",
    left: "50%",
    transform: 'translate(-50%,-50%)',
    textAlign: 'center',
  },
  commentName: {
    fontWeight: 'bold',
    color: 'rgba(50, 60, 71, 1)'
  },
  title:{
    marginLeft:'10px',
  }


});

interface RecentCommentsProps extends WithStyles<typeof styles> {
  recentComments: any[],
}
const RecentComments = (props: RecentCommentsProps) => {
  const { classes, recentComments } = props;
  return (
    <Card className={`${classes.mt1x} ${classes.cardMain}`}>
      <CardContent className={classes.cardContentRoot}>
        <Grid item xs className={classes.title}>
          <Typography variant="h5" noWrap>
            Recent Comments
          </Typography>
        </Grid>
        <div className={classes.fixedHeight}>
        {
          recentComments.length > 0 ? (recentComments.map((recentComment, i) => (
            <Card className={classes.mt1x} key={i}>
              <CardContent className={classes.commentCard}>
                <Grid container alignItems="center" wrap="nowrap" spacing={8} >
                  <Grid item xs="auto">
                    <Avatar alt={`Profile ${recentComment.name}`} src={_.isEmpty(recentComment.imgSrc) ? "/assets/img/profile-default.png" : recentComment.imgSrc} className={classes.bigAvatar} />
                  </Grid>
                  <Grid item xs="auto">

                    <Typography color="textSecondary" className={classes.lineClamp}>
                      <strong className={classes.commentName}>{recentComment.name} </strong>
                      commented on
                      "<span dangerouslySetInnerHTML={{ __html: recentComment.comment }} />"
                    </Typography>
                    <Typography color="textSecondary">
                      <img src="assets/img/dashboard/rectangle.png" className={classes.inline} alt="activity" />
                      {" "}{dateService.getTimeAgo(recentComment.activity)} ago
                </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))) : <Typography className={classes.noContent} color="textSecondary">No Comment</Typography>
        }
        </div>
      </CardContent>
    </Card>
  )
}

export default withStyles(styles)(RecentComments)